import React, { useState } from "react";
import Layout from "@/components/Layout";

export default function Notification() {
  const [notification, setNotification] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleUpdate = async () => {
    // Reset error
    setError("");

    // Validate notification field
    if (!notification.trim()) {
      setError("The notification field is required");
      return;
    }

    setLoading(true);
    try {
      // TODO: Add API call to update notification
      console.log("Updating notification:", notification);
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 500));
      
      // Success - you can add a success message here
      alert("Notification updated successfully!");
    } catch (error) {
      console.error("Error updating notification:", error);
      setError("Failed to update notification. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="p-4 w-full mx-auto bg-[#171b36] min-h-screen">
        {/* Header Section */}
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
          className="shadow-sm px-4 pt-4"
        >
          <div className="flex justify-between items-start">
            <div className="w-full mb-1">
              <div
                style={{ color: "#cae0e8", fontSize: "24px" }}
                className="font-semibold mb-2"
              >
                Notifications
              </div>
              <div className="w-full h-px bg-white"></div>
            </div>
          </div>
        </div>

        {/* Notification Input Section */}
        <div
          style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" , marginTop: '-15px'}}
          className="shadow-sm p-4"
        >
          <div className="flex w-full flex-col gap-4">
            {/* Textarea */}
            <div className="flex-1">
              <textarea
                value={notification}
                onChange={(e) => {
                  setNotification(e.target.value);
                  if (error) setError(""); // Clear error when user types
                }}
                // placeholder="Enter notification text..."
                className="w-full px-2 py-2 text-[14px] bg-white text-black placeholder-black rounded-sm  resize-y min-h-[150px]"
                style={{ fontFamily: 'Lato, Avenir, Verdana, Nunito, sans-serif' }}
              />
              {/* Error Message */}
              {error && (
                <div className="mt-2 text-red-500 text-[14px] font-medium">
                  {error}
                </div>
              )}
            </div>

            {/* Update Button */}
            <div className="flex w-full justify-end -mt-2">
              <button
                onClick={handleUpdate}
                disabled={loading}
                style={{marginTop: '-20px'}}
                className="bg-[#333d79ff] w-[80px] text-white font-bold text-[14px] px-2 py-2 transition-colors hover:bg-[#1a4f66] disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

